import type { JSX } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Permission, usePermissions } from '@/hooks/usePermissions';
import { AppRoutes } from '@/constants/routes';

interface PermissionGuardProps {
    children: JSX.Element;
    requiredPermission: Permission;
}

export function PermissionGuard({
    children,
    requiredPermission,
}: PermissionGuardProps): JSX.Element | null {
    const { isLoading } = useAuth();
    const { has } = usePermissions();

    if (isLoading) {
        return null;
    }

    const hasPermission = has(requiredPermission);

    if (!hasPermission) {
        return <Navigate to={AppRoutes.HOME} />;
    }

    return children;
}

export const OrgOwnerGuard = PermissionGuard;
